import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useAnalyticContext } from '@/modules/analytic/providers/AnalyticProvider';
import { ANALYTICS_KEYS, Block, EventSources, Program } from '@/types';

interface TrackViewContentProps {
  block: Block;
  program: Program;
}

export const useTrackViewContent = () => {
  const { track } = useAnalyticContext();
  const { asPath } = useRouter();

  const trackViewContent = useCallback(
    ({ block, program }: TrackViewContentProps) => {
      const source = asPath.split('/')[1] || EventSources.Home;

      track(ANALYTICS_KEYS.BROWSE_VIEW_CONTENT, {
        blockUUID: block.UUID,
        programUUID: program.UUID,
        program_title: program.title,
        contentOrigin: program?.source,
        domainID: program?.domain,
        picture_url: program.cover,
        source_home: source,
      });
    },
    [asPath, track]
  );

  return { trackViewContent };
};
